// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__66Kq7","logo":"Navbar_logo__FEq1Z","logoImg":"Navbar_logoImg__wIhLC","menus":"Navbar_menus__1G11T"};